module.exports = __webpack_public_path__ + "media/src/images/partners/tpu-f05c3207198a96c62926b86c0ef5d1e3.jpg";